// 뉴스 카테고리 정의
export const NEWS_CATEGORIES = {
  FIRM_NEWS: 'firm_news',
  CASE_ANALYSIS: 'case_analysis',
  LEGAL_NEWS: 'legal_trends',
  LEGAL_COLUMN: 'legal_column',
};

// 뉴스 카테고리 매핑 객체
export const NEWS_CATEGORY_MAPPING = {
  [NEWS_CATEGORIES.FIRM_NEWS]: '법무법인 내부 소식',
  [NEWS_CATEGORIES.CASE_ANALYSIS]: '주요 판례 분석',
  [NEWS_CATEGORIES.LEGAL_NEWS]: '법률 뉴스 및 트렌드',
  [NEWS_CATEGORIES.LEGAL_COLUMN]: '법률 칼럼 및 해설',
}; 